import React, { Component } from 'react';
import { connect, } from 'react-redux';
import axios from 'axios';
import { Container, Spinner, Form, Alert } from 'react-bootstrap';
import { withRouter } from '../withRouter';
import { joinRoom, reconnectToRoom } from 'actions/room';
import * as Sentry from "@sentry/react";
import ErrorModal from '../Utlility/ErrorModal';
import DotLoader from 'components/Utlility/DotLoader';
import LogoWhite from 'images/logo-white.png';

// Will need to refactor form styling into forms.scss as its become a bit of a mess
import formStyles from "components/Forms/FormStyles.module.scss"
import styles from './Join.module.scss';
import AutoJoinModal from '../Roku/AutoJoinModal/AutoJoinModal';

class Join extends Component {
    static displayName = Join.name;

    constructor(props) {
        super(props);

        this.state = {
            roomId: "",
            sessionId: "",
            loading: false,
            nickname: "",
            errorMessage: "",
            checkingRoomOpened: true,
            connectionError: false,
            canJoin: false,
            joinButtonValue: "JOIN",
            QRSessionID: new URLSearchParams(window.location.search).get("QRSessionID"),
            token: "",
            passwordProtected: false,
            pin: "",
            errorVariant: "danger",
            autoActionMode: null,      // 'reconnecting' | 'waiting_for_host' | null
            autoActionStatus: '',      // Status message to display
            reconnectFailed: false,    // If true, forces "Join" button instead of "Reconnect"
        };
        this.cancelToken = null;
    }

    async componentDidMount() {
        // get nickname from local storage
        try {
            const nickname = localStorage.getItem("nickname");
            if (nickname) {
                this.setState({ nickname });
            }
        } catch (e) {
            console.log(e);
        }

        const queryParams = new URLSearchParams(window.location.search);

        if (this.props.room.roomOpen) {
            if (this.props.room.isHost) {
                return setTimeout(() => this.props.navigate("/lobby"));
            } else {
                if (queryParams.has("roku")) {
                    return setTimeout(() => this.props.navigate(`/play?roku`));
                } else {
                    return setTimeout(() => this.props.navigate(`/play`));
                }
            }
        } else {
            this.setState({ checkingRoomOpened: false });
            if (queryParams.has("token")) { // is attempting reconnect?
                // reconnect here
                const token = queryParams.get("token");
                this.setState({
                    autoActionMode: 'reconnecting',
                    autoActionStatus: 'Reconnecting to your session...',
                });
                this.handleReconnect(token);
            } else if (queryParams.has("qrCode")) {
                this.setState({ roomId: queryParams.get("qrCode") });
                await this.handleJoinRoom(queryParams.get("qrCode"));
            } else if (queryParams.has("joinRoom")) {
                // Coming back from external game (e.g., SongBlast) - auto-join the lobby room
                // Use retry logic since client may arrive before host creates the room
                const joinRoomCode = queryParams.get("joinRoom");
                const returnName = queryParams.get("name");
                const returnAvatar = queryParams.get("avatar");
                console.log("Auto-joining lobby room:", joinRoomCode, "name:", returnName, "avatar:", returnAvatar);

                // Set auto-action mode BEFORE starting retry loop
                this.setState({
                    autoActionMode: 'waiting_for_host',
                    autoActionStatus: 'Returning to lobby...',
                    roomId: joinRoomCode,
                    nickname: returnName || this.state.nickname,
                    returnAvatar,
                });
                await this.waitForRoomAndJoin(joinRoomCode);
            }
        }
    }

    componentDidUpdate(prevProps, prevState) {
        const queryParams = new URLSearchParams(window.location.search);

        if (this.props.room.roomOpen === true && prevProps.room.roomOpen === false) {
            if (queryParams.has("roku")) {
                this.props.navigate(`/play?roku`);
            } else {
                this.props.navigate(`/play`);
            }
        }
    }

    onChangeRoomId = async (e) => {
        this.setState({errorMessage: "", passwordProtected: false})
        const roomId = e.target.value.toUpperCase();

        if (roomId.length === 4) {
            this.setState({ roomId, });
            await this.checkGameExists(roomId);
        } else {
            this.setState({ canJoin: false, joinButtonValue: "JOIN", roomId });
        }
    };

    onChangeNickname = (e) => {
        this.setState({ errorMessage: "" })
        const re = /^[A-Za-z0-9 _]*[A-Za-z0-9][A-Za-z0-9 _]*$/;
        const nickname = e.target.value.toUpperCase();
        if (nickname === '' || re.test(nickname)) {
            this.setState({ nickname });
        }
    };

    onChangePIN = (e) => {
        this.setState({ errorMessage: "" })
        this.setState({ pin: e.target.value });
    }

    storeSessionId(id) {
        try {
            localStorage.setItem("sessionId", id);
        } catch (e) {
            console.log(e);
        }
        this.setState({ storedSessionId: id });
    }

    getSessionIdFromStorage() {
        try {
            return localStorage.getItem('sessionId');
        } catch (e) {
            console.log(e);
            return null;
        }
    }


    reloadPage = () => {
        window.location.reload(true);
    }


    async checkGameExists(roomId) {
        const storedSessionId = this.getSessionIdFromStorage();

        if (this.cancelToken != null) {
            this.cancelToken.cancel("Operation canceled due to new request.")
        }

        if (roomId != null) {
            this.cancelToken = axios.CancelToken.source();

            return await axios.get(process.env.REACT_APP_MATCH_MAKE_URL + `/game-exists/?roomId=${roomId}&sessionId=${storedSessionId}`,
                {
                    cancelToken: this.cancelToken.token,
                }
            ).then(res => {
                console.log("Game exists check result");
                console.log(JSON.stringify(res));
                let errorMessage = "";

                if (res.data.gameExists) {
                    // Check if game is at an external server (e.g., Tenable, SongBlast)
                    // Server is the source of truth - if it says go to external game, go there
                    // EXCEPT when isReturning=true - that means players are returning to lobby
                    if (res.data.isExternal && res.data.redirectUrl && !res.data.isReturning) {
                        console.log(`Room ${roomId} is at external game: ${res.data.gameId} (${res.data.displayName})`);
                        console.log(`Redirecting to: ${res.data.redirectUrl}`);
                        // Store nickname for use after redirect
                        if (this.state.nickname) {
                            localStorage.setItem("nickname", this.state.nickname);
                        }
                        // Redirect to external game - append name if we have one
                        let redirectUrl = res.data.redirectUrl;
                        if (this.state.nickname) {
                            redirectUrl += `&name=${encodeURIComponent(this.state.nickname)}`;
                        }
                        window.location = redirectUrl;
                        return res.data;
                    }

                    // If isReturning=true, the external game is ending and players are
                    // going back to lobby - treat as "room not found yet" so retry logic works
                    if (res.data.isExternal && res.data.isReturning) {
                        console.log(`Room ${roomId} is returning from external game - waiting for lobby room`);
                        return { gameExists: false, isReturning: true };
                    }

                    errorMessage = "";
                    if (res.data.passwordProtected) {
                        this.setState({ passwordProtected: true, errorMessage: "Please enter room PIN", errorVariant: "warning" });
                    }

                    if (res.data.playerExists) {
                        this.setState({ joinButtonValue: "Reconnect", errorMessage, canJoin: true, });

                        if (res.data.token.length > 0) {
                            this.setState({ token: res.data.token })
                        }
                    } else {
                        this.setState({ canJoin: !res.data.gameFull, });
                        this.setState({ joinButtonValue: "Join", errorMessage, });
                    }
                } else {
                    errorMessage = `Room '${roomId}' does not exist...`;
                    this.setState({ canJoin: false, errorMessage, errorVariant: "danger" });
                }
                this.cancelToken = null;
                return res.data;
            }).catch((error) => {
                if (axios.isCancel(error)) {
                    console.log('Request canceled');
                }
                console.log({ error });

                this.setState({ connectionError: true });

                return null;
            });
        }
    }

    clickJoinRoom = async (e) => {
        e.preventDefault();
        await this.handleJoinRoom();
    }

    getCookie(name) {
        var nameEQ = name + "=";
        var ca = document.cookie.split(';');
        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) === ' ') c = c.substring(1, c.length);
            if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
        }
        return null;
    }

    async handleJoinRoom(override = null) {
        if (this.state.joinButtonValue === "Reconnect") {
            this.handleReconnect(this.state.token);
        } else {
            let roomId = override ? override : this.state.roomId;
            const gameCheckData = await this.checkGameExists(roomId);

            if (!this.state.loading) {
                if (gameCheckData != null && gameCheckData.playerExists) {
                    let token = gameCheckData.token;
                    this.handleReconnect(token);
                } else {
                    if (gameCheckData.passwordProtected) {
                        if (this.state.pin?.length === 0) {
                            this.setState({ errorMessage: "Please enter room PIN", errorVariant: "warning" })
                            return;
                        }
                    }

                    this.joinRoom(roomId);
                }
            }
        }
    };

    /**
     * Wait for a room to be created and then join it.
     * Used when returning from external games - client may arrive before host creates the room.
     */
    async waitForRoomAndJoin(roomCode, maxRetries = 15, retryDelay = 1000) {
        for (let attempt = 1; attempt <= maxRetries; attempt++) {
            console.log(`[waitForRoomAndJoin] Attempt ${attempt}/${maxRetries} for room ${roomCode}`);

            const gameCheckData = await this.checkGameExists(roomCode);

            if (gameCheckData?.gameExists && !gameCheckData?.isExternal) {
                // Local room exists, proceed to join
                console.log(`[waitForRoomAndJoin] Room ${roomCode} found, joining...`);
                // Keep autoActionMode active - update status to show we're joining
                this.setState({ autoActionStatus: 'Joining room...' });
                await this.handleJoinRoom(roomCode);
                return;
            }

            // Check if room is in 'returning' state (external game ending)
            const isReturning = gameCheckData?.isReturning;

            if (attempt < maxRetries) {
                // Wait before retrying - show appropriate message via autoActionStatus
                const message = isReturning
                    ? `Waiting for host to create lobby... (${attempt}/${maxRetries})`
                    : `Waiting for room... (${attempt}/${maxRetries})`;
                this.setState({
                    autoActionStatus: message,
                });
                await new Promise(resolve => setTimeout(resolve, retryDelay));
            }
        }

        // All retries exhausted, room still doesn't exist - exit auto-action mode and show form
        console.log(`[waitForRoomAndJoin] Room ${roomCode} not found after ${maxRetries} attempts`);
        this.setState({
            autoActionMode: null,     // Exit auto-action mode
            loading: false,
            errorMessage: `Room '${roomCode}' was not created. The host may have encountered an issue.`,
            errorVariant: "danger",
            canJoin: false,
        });
    }

    joinRoom = (roomID, roomPin = null) => {
        console.log("Joining room:", roomID, roomPin, this.state.pin)
        this.setState({ loading: true, errorMessage: "", error: false, });
        let options = {};
        let name = this.state.nickname.length > 0 ? this.state.nickname : "PLAYER";
        options.name = name;

        if (name !== "PLAYER") {
            // store in local storage
            try {
                localStorage.setItem("nickname", name);
            } catch (e) {
                console.log(e);
            }
        }

        // Pass avatar URL if returning from external game (e.g., SongBlast)
        if (this.state.returnAvatar) {
            options.avatarSrc = this.state.returnAvatar;
            console.log("Passing avatar from external game:", options.avatarSrc);
        }

        console.log("Password Protected : ", this.state.passwordProtected)
        if (this.state.passwordProtected) {
            options.password = roomPin ? roomPin : this.state.pin;
        } else if (roomPin) {
            options.password = roomPin;
        }
        console.log("options password : ", options.password);

        this.props.joinRoom(roomID, options).then((res) => {
            if (res.Status === "Error") {
                // Exit auto-action mode to show the form with error
                this.setState({
                    autoActionMode: null,
                    loading: false,
                    errorMessage: res.Message,
                    errorVariant: "danger"
                });
            } else if (res.Status === "Success") {
                console.log("Join Success");
                this.storeSessionId(res.room.sessionId);
                // Navigation happens in componentDidUpdate when roomOpen becomes true
            }
        });
    }


    handleReconnect(token) {
        // Extract roomId from token by splitting on ':' (format: ROOMCODE:sessionId-V3)
        const [roomId] = token && token.includes(':') ? token.split(':') : [this.state.roomId];

        if (!token) {
            this.setState({
                autoActionMode: null,     // Exit auto-action mode
                errorMessage: "There was a problem reconnecting to the room.",
                errorVariant: "danger",
                reconnectFailed: true,    // Force "Join" button
                roomId,                   // Pre-fill room code for fresh join attempt
            });
            return;
        }

        this.setState({ loading: true, errorMessage: "", error: false, roomId });

        setTimeout(() => {
            this.props.reconnectToRoom(token).then(async (res) => {
                if (res.Status === "Error") {
                    this.setState({
                        autoActionMode: null,     // Exit auto-action mode
                        loading: false,
                        errorMessage: res.Message,
                        errorVariant: "danger",
                        token: null,
                        joinButtonValue: "Join",
                        reconnectFailed: true,    // Force "Join" button
                        roomId,                   // Pre-fill room code for fresh join attempt
                    });
                    // Check if room exists to enable the Join button
                    if (roomId && roomId.length === 4) {
                        await this.checkGameExists(roomId);
                        // Force "Join" button since reconnect just failed (checkGameExists may set "Reconnect")
                        this.setState({ joinButtonValue: "Join", token: null });
                    }
                } else if (res.Status === "Success") {
                    console.log("res , ", res);
                }
            });
        }, 1500);
    }

    cancelAutoAction = () => {
        this.setState({
            autoActionMode: null,
            autoActionStatus: '',
            loading: false,
        });
    }

    renderAutoActionScreen() {
        const { autoActionMode, autoActionStatus, roomId } = this.state;

        const title = autoActionMode === 'reconnecting'
            ? 'Reconnecting...'
            : 'Returning to Lobby';

        return (
            <div className={styles.autoActionScreen}>
                <img src={LogoWhite} className={styles.gcLogo} alt="Game City" />
                <h2>{title}</h2>
                {autoActionStatus && <p>{autoActionStatus}</p>}
                {roomId && <p className={styles.roomCode}>{roomId}</p>}
                <DotLoader size="large" variant="light" />
                <button className={styles.cancelButton} onClick={this.cancelAutoAction}>
                    Cancel
                </button>
            </div>
        );
    }

    render() {
        //const player = this.props.room.player;
        return (
            <Container>
                {
                    this.state.checkingRoomOpened ? (
                        <DotLoader size="medium" variant="light" />
                    ) : this.state.autoActionMode ? (
                        this.renderAutoActionScreen()
                    ) : (
                        <div>
                            <h2 className={formStyles.formTitle}>Join a Game</h2>
                            <Form onSubmit={this.clickJoinRoom} >
                                <p>To join a room, just enter the Room Code displayed on your hosts device.<br />Or simply scan the QR Code.</p>
                                <Form.Group className="mb-3" controlId="formBasicEmail">
                                    <Form.Label>Room Code</Form.Label>
                                    <Form.Control type="text" autoComplete="off" maxLength={4} placeholder="Enter Room Id" style={{ textTransform: "uppercase" }} value={this.state.roomId} required onChange={this.onChangeRoomId} />

                                </Form.Group>
                                <Form.Group className="mb-3" controlId="formBasicEmail">
                                    <Form.Label>Nickname</Form.Label>
                                    <Form.Control type="text" autoComplete="off" placeholder="Enter Nickname" style={{ textTransform: "uppercase" }} value={this.state.nickname} maxLength={10} minLength={2} required={this.state.joinButtonValue !== "Reconnect"} onChange={this.onChangeNickname} />
                                </Form.Group>
                                {
                                    this.state.passwordProtected &&
                                    <Form.Group className="mb-3" controlId="formBasicEmail">
                                        <Form.Label>Room PIN</Form.Label>
                                        <Form.Control type="password" autoComplete="off" placeholder="Enter Room PIN" style={{ textTransform: "uppercase" }} value={this.state.pin} maxLength={8} minLength={4} required={this.state.joinButtonValue !== "Reconnect"} onChange={this.onChangePIN} />
                                    </Form.Group>
                                }
                                <button className={formStyles.button} disabled={!this.state.canJoin} variant="primary" type="submit">
                                    {this.state.loading ? <DotLoader size="medium" variant="light" /> : this.state.joinButtonValue}
                                </button>
                                {
                                    this.state.errorMessage.length > 0 &&
                                    <Alert variant={this.state.errorVariant}>
                                        {this.state.errorMessage}
                                    </Alert>
                                }
                            </Form>
                        </div>
                    )
                }
                {
                    this.state.QRSessionID && <AutoJoinModal onComplete={this.joinRoom} QRSessionID={this.state.QRSessionID} />
                }
                { this.state.connectionError &&
                            <ErrorModal
                    title={"Disconnected"}
                    styles={"d-flex"}
                    message={"There is a problem connecting to the lobby. Please refresh and try again, if the problem persists it may be a firewall blocking your attempts."}
                    callback={this.reloadPage}
                    callbackText={"Try again" }
                            />
                 }
            </Container>
        );
    }
}


const mapStateToProps = (state) => {
    return {
        auth: state.auth,
        room: state.room,
    };
}


const mapDispatchToProps = (dispatch) => {
    return {
        joinRoom: (roomId, options) => {
            return dispatch(joinRoom(roomId, options))
        },
        reconnectToRoom: (token) => {
            return dispatch(reconnectToRoom(token))
        }
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Join));
